document.addEventListener("DOMContentLoaded", function () {
  // Language Switcher
  document.querySelectorAll('.nav-lang-switcher').forEach(selectLang => {
    selectLang.addEventListener('change', event => {
      let current_locale = Shopify.locale == 'en' ? '' : Shopify.locale + '/';
      let new_locale = selectLang.value == 'en' ? '' : selectLang.value + '/';
      location.href = location.href.replace(location.host + '/' + current_locale, location.host + '/' + new_locale);
    });
  })

  // Language Switcher - Variation
  document.querySelectorAll('.nav-lang-switcher-variation a').forEach(selectLang => {
    selectLang.addEventListener('click', event => {
      let current_locale = Shopify.locale == 'en' ? '' : Shopify.locale + '/';
      let new_locale = selectLang.dataset.locale == 'en' ? '' : selectLang.dataset.locale + '/';
      location.href = location.href.replace(location.host + '/' + current_locale, location.host + '/' + new_locale);
    });
  })
  
  var scrollToReviewsSpan = document.getElementById("scrollToReviews");
  if (scrollToReviewsSpan) {
    scrollToReviewsSpan.addEventListener("click", function () {
      var reviewsSection = document.querySelector(
        ".js-oke-widgetSize.oke-is-large, .js-oke-widgetSize.oke-is-small"
      );

      if (reviewsSection) {
        // Scroll smoothly to the reviews section
        reviewsSection.scrollIntoView({
          behavior: "smooth",
        });
      }
    });
  }

  waitForElm(".product-details-wrapper [data-oke-metafield-data]").then(
    (elm) => {
      const metafield = jQuery.parseJSON(elm.textContent);
      if (metafield.reviewCount == 0) {
        $(".product-details-wrapper [data-oke-star-rating]").css({
          display: "none",
        });
        $(".trustedbypdp").css({ display: "none" });
      } else {
        $(".product-details-wrapper [data-oke-star-rating]").css({
          display: "block",
        });
        $(".trustedbypdp").css({ display: "block" });
      }
    }
  );
});

const customSelectors = {};

const menuLinks = document.querySelectorAll(".mega_menu_hover_line");
const subMenuContents = document.querySelectorAll(".sub_menu");

menuLinks.forEach((menuLink) => {
  menuLink.addEventListener("mouseover", function (e) {
    const element = e.target.closest(".mega_menu_hover_line"); // Ensures we always target the <a> tag
    
    if (!element) return; // Safety check

    menuLinks.forEach((menuLink) => {
      menuLink.classList.remove("mega-menu__link--active");
    });
    element.classList.add("mega-menu__link--active");

    const menu_title = element.title; // Use the closest <a> title
    const menu_link = element.href;

    if (menu_title != 'Shop All Products') {
    //if (!/\/collections\/all$/.test(menu_link)) {
      subMenuContents.forEach((subMenuContent) => {
        subMenuContent.classList.remove("active");
        const handle = subMenuContent.getAttribute("data-menu-title");
        if (handle == menu_title) {
          subMenuContent.classList.add("active");
        }
      });
    //}
    }
  });
});


const inputElement = document.querySelector(".docapp-coupon-input--input");
if (inputElement)
  inputElement.setAttribute("placeholder", "+ ENTER DISCOUNT CODE");

function sanitizePrice(priceString) {
  // Remove any non-digit characters except for the decimal point
  let numericString = priceString.replace(/[^\d.]/g, "");
  const numeric = priceString.includes(",")
    ? numericString * 1
    : numericString * 100;
  // Convert the clean string to a float to handle numbers correctly
  return parseFloat(numeric);
}

function calculatePriceWithTaxes(price, country, showTaxes = false) {
  const taxData = window.taxData;

  const noPriceDisplayCountries = ["US", "CA"];

  let taxRate = taxData[country];
  
  if(taxRate == 0) {
    return `<span class="tax-excl-price">${price.toString().replace(/\./g, ",")} ${window.globalVariables.money_format.replace("{{amount_with_comma_separator}} ","")}</span><span class='tax tax-excl'> Excl. Tax</span>`;
  }
  
  let taxInclusivePrice = price * (1 + taxRate);
  let formattedTaxInclusivePrice = Shopify.formatMoney(
    taxInclusivePrice,
    window.globalVariables.money_format
  );
  let formattedTaxExclusivePrice = Shopify.formatMoney(
    price,
    window.globalVariables.money_format
  );

  if (country === "LU") {
    return `<span class="tax-excl-price">${formattedTaxExclusivePrice}</span><span class='tax tax-excl'> Excl. Tax</span> <span>${formattedTaxInclusivePrice}</span><span class='tax'> Incl. Tax</span>`;
  } else if (taxRate !== undefined && showTaxes) {
    return formattedTaxInclusivePrice + "<span class='tax'> Incl. Tax</span>";
  } else if (taxRate !== undefined) {
    return formattedTaxInclusivePrice;
  }

  return noPriceDisplayCountries.includes(country)
    ? formattedTaxExclusivePrice
    : formattedTaxExclusivePrice +
        (showTaxes ? "<span class='tax'> Excl. Tax</span>" : "");
}

document.addEventListener("DOMContentLoaded", function () {
  const customerCountry = window.customerCountry;
  waitForElm(".cbb-frequently-bought-selector-label-regular-price", 5000).then(
    () => {
      function changePrices() {
        const prices = document.querySelectorAll(
          ".cbb-frequently-bought-selector-label-regular-price, .cbb-frequently-bought-selector-label-compare-at-price, .cbb-frequently-bought-selector-label-sale-price, .cbb-frequently-bought-total-price-sale-price, .cbb-frequently-bought-total-price-was-price, .cbb-frequently-bought-total-price-regular-price"
        );
        prices.forEach((price) => {
          const hasAnyClass = [
            "cbb-frequently-bought-selector-label-compare-at-price",
            "cbb-frequently-bought-total-price-was-price",
          ].some((className) => price.classList.contains(className));

          const priceElement = price.querySelector(".money")
            ? price.querySelector(".money")
            : price;

          //console.log("priceElement", priceElement.textContent);
          const priceWithTaxes = calculatePriceWithTaxes(
            sanitizePrice(priceElement.textContent),
            customerCountry,
            hasAnyClass ? false : true
          );

          //console.log("priceWithTaxes", priceWithTaxes);
          priceElement.innerHTML = priceWithTaxes;
        });
      }

      setTimeout(() => {
        const variantSelects = document.querySelectorAll(
          ".cbb-recommendations-variant-select"
        );

        //console.log("variantSelects", variantSelects);

        if (variantSelects.length > 0) {
          variantSelects.forEach((select) => {
            select.addEventListener("change", () => {
              changePrices();
            });
          });
        }

        changePrices();
      }, 1000);
    }
  );
});



$(".submenu-accordion").on("click", function () {
  $(".submenu-accordion").not(this).removeAttr("open");

  /*
  $(this).parent().find(".nav-item-shop-topical-skincare .submenu-accordion").each(()=>{      
    if($(this).attr("open")){
        $(".nav-item-shop-topical-skincare .submenu-div .nav-item").show();
    }else{
        $(".nav-item-shop-topical-skincare .submenu-div .nav-item").hide();    
    }
  })
  */
});


$(document).ready(function () {
  $(".products-menu").hover(function () {
    let $this = $(this);
    let topLevelAnchorUrl = $this.children("a").attr('href').trim();
    
    $(".sideproduct .active").removeClass("active");
    $(".nav-item.nav-item-anim.py-0 a").removeClass("mega-menu__link--active");
    
    if (topLevelAnchorUrl.includes('/collections/all')) {
      if (document.documentElement.classList.contains('abtest-menu-variation-1')) {
        $this.find('.nav-item:eq(1) a').addClass("mega-menu__link--active");
        $this.find('.sub_menu:eq(1)').addClass("active");
        $this.find('.nav-item-all-devices').children("ul").show();
      } else {
        $this.find('.nav-item:eq(0) a').addClass("mega-menu__link--active");
        $this.find('.sub_menu:eq(0)').addClass("active");
      }
    }
  });

  $('.dropdown-menu .nav-item.has-children').hover(function() {
    $(this).children('ul').show();
    $(this).siblings().children('ul').hide();
  });
  
  $(".sideproduct").hover(function () {
    var menuTitle = $(this).find(".active").attr("data-menu-title");
    // console.log(menuTitle);
      
    if(menuTitle == "Topical Skincare" || menuTitle == "Topicals for Anti-Aging" || menuTitle == "Topicals for Blemish-Prone Skin" || menuTitle == "Hydrocolloid Patch Refills" || menuTitle == "Shop All Topical Skincare" ){
      //$(".has-children .thirdlink-child-link").hide();               
      $(".nav-item-all-devices a").removeClass("mega-menu__link--active");          
      $(".nav-item-skin-care a").addClass("mega-menu__link--active");
      //$(".nav-item-skin-care").find(".thirdlink-child-link").show();

    } else if(menuTitle == "Devices" || menuTitle == "Anti-Aging Devices" || menuTitle == "Anti-Acne Devices" || menuTitle == "Mini Devices" ){
      //$(".has-children .thirdlink-child-link").hide();            
      $(".nav-item-all-devices a").addClass("mega-menu__link--active");
      //$(".nav-item-all-devices").find(".thirdlink-child-link").show();

    } else{
      $(".nav-item-skin-care a").removeClass("mega-menu__link--active");
      //$(".nav-item-skin-care").find(".thirdlink-child-link").hide();
    } 
  });

  function checkDesktop() {
    return $(window).width() > 768; // Adjust breakpoint as needed
  } 
});

(function(history) {
  const pushState = history.pushState;
  history.pushState = function(state, title, url) {
    const result = pushState.apply(this, arguments);
    window.dispatchEvent(new Event("urlchange"));
    return result;
  };

  const replaceState = history.replaceState;
  history.replaceState = function(state, title, url) {
    const result = replaceState.apply(this, arguments);
    window.dispatchEvent(new Event("urlchange"));
    return result;
  };
})(window.history);

window.addEventListener("urlchange", () => {
  // console.log("URL changed:", location.href);
});


/* Variation 11.0.2 */
function getOS() {
  const ua = navigator.userAgent || navigator.vendor || window.opera;

  // ---- iPhone, iPod, older iPads ----
  if (/iPhone|iPod/.test(ua)) {
    return 'iOS';
  }

  // ---- iPadOS 13+ (iPads that report as "MacIntel") ----
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
    return 'iOS (iPadOS)';
  }

  // ---- Real macOS ----
  if (/Macintosh|Mac OS X/.test(ua)) {
    return 'macOS';
  }

  return 'other';
}


function isSafariSupported() {
  const osName = getOS();

  return osName == 'macOS' || osName.includes('iOS');
}

function runExperiment_ol006(){
    //Experiment base class  NOTE: try not to modify
    class CROExperiment{
        constructor($props = {debug: true}){
            this.setDebug = (typeof($props.debug) !== 'undefined') ? $props.debug : true;
            this.setProps($props);
            this.getJQuery = new Promise(this.hasJQuery);
            this.jQuery = null;
            this.log = [];
        }
        setProps($props){
            for(const $prop in $props){
                if($prop !== 'debug'){
                    this[$prop] = $props[$prop];
                }
            }
        }
        hasJQuery($resolve,$reject){
            let $jQuery = false;
            let $w = setInterval(() => {
                if(typeof(jQuery) !== 'undefined'){
                    clearInterval($w);
                    $jQuery = true;
                    return $resolve(jQuery);
                }
                if(typeof(convert.$) !== 'undefined'){
                    clearInterval($w);
                    $jQuery = true;
                    return $resolve(convert.$);
                }
            }, 50);
            setTimeout(() => {
                if(!$jQuery){
                    clearInterval($w);
                    return $reject(null);
                }
            }, 2000);
        }
        hasNode($selector){
            return (document.querySelectorAll($selector).length > 0) ? true : false;
        }
        debug($string, $styles = `color:#f00;background-color:#000`){
            if(this.setDebug){
                // console.log(`%c[QA ${this.slug || 'testId'} DEBUG] -> ${$string}`, $styles);/
            }
        }
        addToLog($string = ''){
            const $date = new Date();
            const $data = `${$date.getHours()}:${$date.getMinutes()}:${$date.getSeconds()}:${$date.getMilliseconds()}: ${$string}`;
            this.log.push($data);
        }
        outputLog($styles = `color:#0f0;background-color:#000;padding: 10px;`){
            let $str = ``;
            const $original_state = this.setDebug;
            if(!$original_state){
                this.setDebug = true;
            }
            this.log.forEach(($item, $ic)=>{
                const $break = ($ic === this.log.length - 1) ? `` : `\n`
                $str = `${$str}${$item}${$break}`;
            });
            this.debug($str, $styles);
            if(!$original_state){
                this.setDebug = false;
            }
        }
        addObserver($selector, $callback = ($mutationList, $observer)=>{}, $config = {attributes:true, attributesOldValue: true, attributeFilter: ['class']}){
            this.wait($selector, ()=>{
                const $node = document.querySelectorAll($selector);
                $node.forEach(($s)=>{
                    const $observer = new MutationObserver($callback);
                    $observer.observe($s, $config);
                });
            });
        }
        wait($selector, $resolve, $reject = ()=>{}, $duration = 10, $delay = 2000, $returnJQuery = false){
            let $hasElem = false;
            let $interval = setInterval(() => {
                if(this.hasNode($selector)){
                    clearInterval($interval);
                    $hasElem = true;
                    const $node = (this.jQuery !== null && $returnJQuery) ? this.jQuery($selector) : document.querySelectorAll($selector);
                    $resolve($node);
                }
            },$duration);
            setTimeout(() => {
                if(!$hasElem){
                    clearInterval($interval);
                    $reject();
                }
            }, $delay);
        }
        getBasicBlock($data = {tag: `div`}){
            const $keys = (this.isPlainObject($data)) ? Object.keys($data) : [];
            let $block = document.createElement(`div`);
            if($keys.length > 0 && $keys.includes(`tag`)){
                $block = document.createElement($data.tag);
                if(typeof $data.id !== 'undefined'){
                    $block.id = $data.id;
                }
                if(typeof $data.classnames !== 'undefined' && Array.isArray($data.classnames)){
                    $block.classList.add(...$data.classnames);
                }
            }
            return $block;
        }
        isPlainObject($data){
            return typeof $data === 'object' && $data !== null && !Array.isArray($data) && $data.constructor === Object;
        }
        run(){
            this.addToLog('script version: 11.0.2');
            this.addToLog(`Experiment: ${this.experiment || 'Experiment Name'}`);
            this.addToLog(`${this.variation || 'Variation 1'}: ${this.variationTitle || 'Variation title'}`);
            this.addToLog(`Version: ${this.version || 'v1.0.0'}`);
            this.addToLog('running...');
            this.wait('body', ($body)=>{
                $body[0].setAttribute(`data-cro-test-${this.slug || 'testId'}`, this.version || 'v1.0.0');
                $body[0].setAttribute(`data-cro-test-${this.slug || 'testId'}-variation`, this.versionIndex || '1');
            });
        }
    }

    //extra classes here if needed
    class ShopifyCartAPI{
        constructor($sessionTag = 'croCartSession'){
            this.sessionTag = $sessionTag;
        }
        /**
         * $data = object {items: [{id: NUMBER, quantity: NUMBER}]}
         * $callBack = function ()=>{} what to do when the product is added to cart
         * $redirect = boolean set true to redirect to another page like the cart page or checkout page
         */
        async add($data, $callBack, $redirect = false){
            const $t = this;
            if($data.items.length > 0){
                const $t = this;
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type':'application/json',
                        'Accept':'application/json'
                    },
                    body: JSON.stringify($data)
                }).then(()=>{
                    $t.get(($r)=>{
                        if($redirect){
                            $callBack();
                        }
                        else{
                            $callBack($r);
                        }
                    });
                });
            }
        }
        async get($callBack){
            const $t = this;
            fetch('/cart.js').then(($res)=>{
                return $res.json();
            }).then(($data)=>{
                window.sessionStorage.setItem($t.sessionTag, JSON.stringify($data));
                $callBack($data);
            });
        }
        /**
         * $data is a JSON value with key item and quantity example: {id: CART_ITEM_KEY, quantity: NUMBER}
         * or
         * $data is a JSON value with cart line item and quantity example: {line: LINE_NUMBER, quantity: NUMBER}
         */
        async update($data, $callBack){
            const $t = this;
            fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type':'application/json',
                    'Accept':'application/json'
                },
                body: JSON.stringify($data)
            }).then(($res)=>{
                return $res.json();
            }).then(($data)=>{
                window.sessionStorage.setItem($t.sessionTag, JSON.stringify($data));
                $callBack($data);
            });
        }
        /** 
         * $code is the active coupon code 
        */
        async coupon($code, $callback = ()=>{}){
            fetch('/discount/' + $code).then(async ()=>{
                return fetch('/cart/update.js',{
                    method: 'POST',
                    headers: {
                        'Content-Type':'application/json',
                        'Accept':'application/json'
                    },
                    body: JSON.stringify({
                        updates: {}
                    })
                }).then(()=>{
                        $callback();
                    });
            }).catch(($error)=>{
                console.error('Error ', $error);
            });
        }
    }

    //Create Experiment Class that extends the base CROExperiment class - NOTE: Here is where to add functions need for the test experiment
    class Experiment extends CROExperiment{
        constructor($props){
            super($props);
        }
        run(){
            super.run();
            this.getJQuery.then(($reponse)=>{
                //this.addToLog('run experiment');
                this.jQuery = $reponse;
                this.start();
            },($reponse)=>{
                //this.addToLog('stop experiment');
                this.jQuery = $reponse;
            });
        }
        start(){
            this.addToLog(`Start of test variation code.`);
            const $t = this;
            this.wait(`#ol006-apple-pay-button`,($btn)=>{
              $btn[0].parentElement.style.display = 'block';
              $btn[0].addEventListener(`click`,($e)=>{
                $e.preventDefault();
                const $this = ($e.target.nodeName.toLowerCase() === 'button') ? $e.target : $e.target.closest('button');
                const $vid = parseInt($e.target.closest(`form`).querySelector(`[name="id"]`).value);
                const $qty = parseInt($e.target.closest(`form`).querySelector(`[name="quantity"]`).value);
                const $data = {items: [{id: $vid, quantity: $qty}]};
                $this.setAttribute('disabled', 'disabled');
                $t.cart.add($data, ()=>{
                    $this.removeAttribute('disabled');
                    window.location.href = `/checkout/`;
                }, true);
              });
            });
        }
    }

    //Experiment Props;
    const $props = {
        slug: 'ol006',
        experiment: 'OL006 - A/B Test | Apple Pay to Mobile ATC CTA',
        variation: 'Variation 1',
        variationTitle: `A/B Test | Apple Pay to Mobile ATC CTA`,
        version: 'v1.0.0',
        versionIndex: '1',
        variationID:1,
        cart: new ShopifyCartAPI()
    };

    //create new Experiment instant and run
    const ol006_Experiment = new Experiment($props);
    ol006_Experiment.run();  
}

if (isSafariSupported()) {
  runExperiment_ol006();
}